import mockData from '@/utils/mock.json';

export function getMockData() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockData);
    }, 1000); // 模拟请求延迟
  });
}
